import React from 'react';
import styles from './hero-logos.module.css';

const FEATURED_LOGOS = [
  { name: "NPR", src: "/assets/logos/npr-logo.svg" },
  { name: "LifeKit", src: "/assets/logos/lifekit.png" },
  { name: "9News", src: "/assets/logos/9news.png" },
  { name: "Women's Health", src: "/assets/logos/wh-logo.webp" },
  { name: "Prevention", src: "/assets/logos/prevention-logo.webp" },
  { name: "Maria Shriver's Sunday Paper", src: "/assets/logos/maria-shriver-logo.svg" },
];

export default function HeroLogos() {
  return (
    <div className={styles.heroLogosContainer}>
      <div className={styles.header}>
        As featured in
      </div>
      <div className={styles.logosWrapper}>
        {FEATURED_LOGOS.map((logo, index) => (
          <img
            key={index}
            src={logo.src}
            alt={logo.name}
            className={styles.logoImage}
            title={logo.name}
          />
        ))}
      </div>
    </div>
  );
}
